export default __webpack_public_path__ + "static/shan-48bb62894f68c85fc48331f8af667ffa.jpg";